import { createPolymorphicComponent, Drawer, DrawerProps } from "@mantine/core"
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DefaultTheme } from "src/theme/theme";
import styled from "styled-components";

const _StyledDrawer = styled(Drawer)`
    @media (max-width: ${DefaultTheme.breakpoints.md}) {
        --drawer-size: 80% !important;
    }
    @media (max-width: ${DefaultTheme.breakpoints.sm}) {
        --drawer-size: 100% !important;
    }
`
const StyledDrawer = createPolymorphicComponent<'div', DrawerProps>(_StyledDrawer)

export const RouteDrawer = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const close = () => {
        if (location.state?.drawerFrom) {
            navigate(location.state.drawerFrom, { replace: true });
        } else {
            navigate("..", { replace: true });
        }
    };

    return (
        <StyledDrawer
            opened
            onClose={close}
            withCloseButton={false}
            padding={0}
            size="70%"
            trapFocus
            position="right"
            className="route-drawer"
            styles={{
                body: {
                    height: 'calc(100%)',
                    minHeight: 'calc(100%)',
                    maxHeight: 'calc(100%)'
                },
            }}
        >
            <Outlet />
        </StyledDrawer>)
}